import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import getEmitter from '/auto-message/src/postmessage/emitter'
import ellipsis from '/auto-message/src/common/js/lib/ellipsis';
import style from './style.scss';
import TextDisplay from './TextDisplay'

import CancelImage from './Cancel'


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
            message: props.message,
            hover: false
        }
        this.handleAutoMessageClick = this.handleAutoMessageClick.bind(this);
        this.state = {message: props.message}
        this.emitter = getEmitter()
    }

    componentWillReceiveProps(nextProps, nextState){
        this.setState({message: nextProps.message, visible: true})
        if(nextProps.message){
            const payload = {
                duration: nextProps.duration,
                open: nextProps.openState,
            }
            this.emitter.send('clientWebsite', 'displayAutoMessage', payload);
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(this.auto){
            this.emitter.send('clientWebsite', 'autoMessageHeight', this.auto.offsetHeight);
        }
    }

    render() {
        if (!this.props.message) return null
        if(!this.state.visible) return null
        if(this.props.isOffline) return null
        return (
            <div
                ref={auto => this.auto = auto}
                onClick={this.handleAutoMessageClick}
                onMouseEnter={()=>{this.setState({hover: true})}}
                onMouseLeave={()=>{this.setState({hover: false})}}
                className={style.AutoMessage}>
                <div className={style.CloseButton} onClick={(event)=>{
                        event.stopPropagation();
                        this.setState({visible: false});
                }}
                >
                    { (this.props.onMobileView || this.state.hover) &&(
                        <div>
                        <CancelImage color='black'/>
                        </div>
                    )}
                </div>
                <span className={style.AutoMessageText}>
                    <TextDisplay text={this.props.message}/>
                </span>
            </div>
        );
    }

    handleAutoMessageClick() {
        this.emitter.send('*', 'openState', true);
    }

}

function mapStateToProps(state) {
    return {
        openState : state.get('state', false),
        message: state.getIn(['autoMessage', 'message']),
        duration: state.getIn(['autoMessage', 'message_duration'], 3),
        onMobileView: state.getIn(['system', 'payload', 'onMobileView']),
        isOffline: state.getIn(['system', 'payload', 'features_payload', 'offline', 'status'], false)

    };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./components/App.js